import { recurrencyCopy } from '../copy'

export const RecurrencyHowItWorks = () => (
  <section aria-labelledby="recurrency-how-it-works" className="flex flex-col gap-4">
    <h2 id="recurrency-how-it-works" className="text-xl font-semibold text-gray-900 md:text-2xl">
      {recurrencyCopy.howItWorks.title}
    </h2>
    <ol className="grid list-none grid-cols-1 gap-4 p-0 md:grid-cols-2 lg:grid-cols-4">
      {recurrencyCopy.howItWorks.steps().map((step, index) => (
        <li key={step.title} className="flex flex-col gap-2 rounded-xl bg-white p-5">
          <span
            aria-hidden="true"
            className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-gray-800">
            {index + 1}
          </span>
          <h3 className="text-base font-semibold text-gray-900">{step.title}</h3>
          <p className="text-sm text-gray-600">{step.body}</p>
        </li>
      ))}
    </ol>
  </section>
)
